// extracted by mini-css-extract-plugin
var _1 = "Footer_container__8EcQB";
var _2 = "Footer_spacer__7WNQW";
export { _1 as "container", _2 as "spacer" }
